import M_ENV from '../../../../main/components/env/index.js'
import M_TOOLKIT from '../../../../main/components/toolkit/index.js'
 
// 事件监听
const M_EVENT_LISTENER = (instance) => {

    // 非APP环境上报
    if (!M_ENV.isInApp){
        _page_inter_event(instance)
        _page_leave_event(instance)
        _page_stay_event(instance)
    } 

    // click事件只有无痕上报开启时才上报
    if (instance.tracelessSwitch) {
        M_ENV.isWeexNativeInApp ? _weex_page_click_event(instance) : _h5_page_click_event(instance)
    }
}

// 页面进入事件
const _page_inter_event = (instance) => {
     
    window.addEventListener('load', (e) => {
        !instance.isReportPv && instance._pageViewReport()
    }, true)

    window.addEventListener('viewshow', (e) => {
        !instance.isReportPv && instance._pageViewReport()
    }, true)

    window.addEventListener('pageshow', (e) => {
        !instance.isReportPv && instance._pageViewReport()
    }, true)

    window.addEventListener( 'beforeunload', (e) => {
        instance.isReportPv = false
    }, true)

    window.addEventListener( 'unload', (e) => {
        instance.isReportPv = false
    }, true)

    window.addEventListener( 'pagehide', (e) => {
        instance.isReportPv = false
    }, true)

    window.addEventListener( 'viewhide', (e) => {
        instance.isReportPv = false
    }, true)
}

// 页面离开事件
const _page_leave_event = (instance) => {

    window.addEventListener( 'beforeunload', (e) => {
        if (!instance.isReportLeave) {
            instance._leaveReporter()
            instance._forceReporter()
        }
    }, true)

    window.addEventListener( 'unload', (e) => {
        if (!instance.isReportLeave) {
            instance._leaveReporter()
            instance._forceReporter()
        }
    }, true)
    
    window.addEventListener( 'pagehide', (e) => {
        if (!instance.isReportLeave) {
            instance._leaveReporter()
            instance._forceReporter()
        }
    }, true)

    window.addEventListener( 'viewhide', (e) => {
        if (!instance.isReportLeave) {
            instance._leaveReporter()
            instance._forceReporter()
        }
    }, true)
}

// 页面停留事件
const _page_stay_event = (instance) => {
    
    window.addEventListener( 'beforeunload', (e) => {
        instance.pageExitTime = M_TOOLKIT.getTime()
        instance.isReportPageStay && instance._pageStayReport()
    }, true)

    window.addEventListener( 'unload', (e) => {
        instance.pageExitTime = M_TOOLKIT.getTime()
        instance.isReportPageStay && instance._pageStayReport()
    }, true)

    window.addEventListener( 'pagehide', (e) => {
        instance.pageExitTime = M_TOOLKIT.getTime()
        instance.isReportPageStay && instance._pageStayReport()
    }, true)

    window.addEventListener( 'viewhide', (e) => {
        instance.pageExitTime = M_TOOLKIT.getTime()
        instance.isReportPageStay && instance._pageStayReport()
    }, true)

    window.addEventListener( 'viewshow', (e) => {
        instance.isReportPageStay = false
        instance.initTime = M_TOOLKIT.getTime()
    }, true)

    window.addEventListener( 'pageshow', (e) => {
        if (typeof window.webkit != 'undefined') {
            instance.isReportPageStay = false
            instance.initTime = M_TOOLKIT.getTime()
        }
    }, true)
}

// h5页面点击事件
const _h5_page_click_event = (instance) => {
    if (M_ENV.isInApp && M_ENV.isWeex) {
        let globalEvent = weex.requireModule('globalEvent')
        globalEvent.addEventListener('click', (e) => {
            e.isTraceless = true
            instance.tracelessSwitch && instance._domReportHandler(e)
        })
    } else {
        window.addEventListener('click', (e) => {
            e.isTraceless = true
            instance.tracelessSwitch && instance._domReportHandler(e)
        }, true)
    }
}

// weex页面点击事件
const _weex_page_click_event = (instance) => {
    if (weex && weex.document && weex.document.body) {
        weex.document.body.setAttr('bubble', 'true', false)
        weex.document.body.addEvent('click', (e) => {
            e.isTraceless = true
            instance.tracelessSwitch && instance._domReportHandler(e)
        }, {})
    }
}

export default M_EVENT_LISTENER